import handler from '../handler/handler';
import messages from '../handler/messages/messages';

const statusHandler = handler(messages);

export default {
  state: {
    aromas: null,
  },
  getters: {
    getAromaList: state => state.aromas,
  },
  mutations: {
    successAromas: (state, payload) => {
      state.aromas = payload;
    },
  },
  actions: {
    getAromaList: async ({ commit, getters }) => {
      const result = await statusHandler.authGet({ commit, getters }, '/api/aromas/');

      commit('successAromas', result.response.result.rows);
      return result.response.result.rows;
    },

    updateAroma: async ({ commit, getters }, data) => {
      const aroma = {
        id: data.id,
        code: data.code,
        name: data.name,
        img: data.img,
        is_checked: data.isChecked,
      };

      const result = await statusHandler.authPut({ commit, getters }, `/api/aromas/${aroma.id}`, aroma);
      return result;
    },

    createEmptyAroma: async ({ commit, getters }) => {
      const result = await statusHandler.authPost({ commit, getters }, '/api/aromas/');
      return result;
    },

    deleteAroma: async ({ commit, getters }, id) => {
      const result = await statusHandler.authDelete({ commit, getters }, `/api/aromas/${id}`);
      return result;
    },

    deleteAromas: async ({ commit, getters }, ids) => {
      const result = await statusHandler.authPatch({ commit, getters }, '/api/aromas/delete', ids);
      return result;
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/aroma.js